export type JobPositionsProps = {
  high_risk?: boolean | null;
};

export type JobSpecialtiesProps = {
  id?: number | null;
  label?: string | null;
};

export type MissingHighRiskSpecialtiesProps = {
  specialty_id?: number | null;
  label?: string | null;
} | null;

type HasMatchingSpecialtiesForHighRiskJobProps = {
  jobSpecialties?: JobSpecialtiesProps[] | null;
  jobPositions?: JobPositionsProps[] | null;
  userSpecialties?: JobSpecialtiesProps[] | null;
};

export const hasMatchingSpecialtiesForHighRiskJob = ({
  userSpecialties,
  jobPositions,
  jobSpecialties,
}: HasMatchingSpecialtiesForHighRiskJobProps) => {
  const hasNoHighRiskPosition = jobPositions?.some((position) => !position.high_risk);
  if (hasNoHighRiskPosition) {
    return true;
  }
  const inputUserSpecialties = userSpecialties || [];
  const inputJobSpecialties = jobSpecialties || [];
  const needsMoreSpecialties = inputJobSpecialties.every((jobSpec) =>
    inputUserSpecialties.some((userSpec) => userSpec.id === jobSpec.id),
  );

  return needsMoreSpecialties;
};

type GetMissingSpecialtiesIdsProps = {
  jobSpecialties?: JobSpecialtiesProps[] | null;
  userSpecialties?: JobSpecialtiesProps[] | null;
};

export const getMissingSpecialtiesOptions = ({
  jobSpecialties,
  userSpecialties,
}: GetMissingSpecialtiesIdsProps) => {
  if (!jobSpecialties) {
    return [];
  }
  const jobSpecialtiesIds = jobSpecialties?.map(({ id }) => id) || [];
  const userSpecialtiesIds = userSpecialties?.map(({ id }) => id) || [];
  const jobSpecialtiesIdsNeededData = jobSpecialtiesIds?.filter(
    (s) => !userSpecialtiesIds.includes(s),
  );

  const specialtiesMissing = jobSpecialties?.filter(({ id }) =>
    jobSpecialtiesIdsNeededData.includes(id),
  );

  const options = specialtiesMissing?.map((specialty) => {
    return {
      value: specialty?.id as number,
      label: specialty?.label as string,
    };
  });

  return options;
};
